import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import { useSuperTokensUserId } from "@/authentication/AuthenticationStateProvider";
import { usePostHog } from "@/external/posthog-client";
import { useSessionUser } from "@/hooks/Network/useSessionUser";

/** Synchronizes the root dashboard identity with external analytics. Never mounted by nested project scopes. */
export function SessionIdentity(): null {
  const user = useSessionUser();
  const identity = useSuperTokensUserId();
  const postHog = usePostHog();
  useEffect(() => {
    let segment = "Resident";
    if (user.isSuperAdmin) {
      segment = "Super admin";
    } else if (user.isAdmin) {
      segment = "Professional user";
    }
    Sentry.getCurrentScope().setUser({
      email: user.email,
      username: identity,
      segment,
    });

    return () => {
      Sentry.getCurrentScope().setUser(null);
    };
  }, [user, identity]);
  useEffect(() => {
    if (identity) {
      postHog?.identify(identity, {
        userId: user.id,
        projectId: user.projectId,
        email: user.email,
        isAdmin: user.isAdmin,
      });
    }
  }, [user, identity, postHog]);

  return null;
}
